import { useEffect, useRef } from "react"
import { StandardButton } from "../atoms/buttons"
import { IconAtom } from "../atoms/iconAtom"
import { InputForm } from "../atoms/input"
import { icon } from "../functions/icons"
import { color } from "chart.js/helpers"
import { Alert } from "../components/alert"

export const LessonTitle = ({ lessonInformation,changeIndex, onClick,navigation,remove ,replaceContainer, message}) => {
    
    return (


        <div  data-testid={'lesson-title-comp'} className="horizontal" >
            <div className="horizontal" >
        	    <IconAtom onClick={changeIndex} icon2={"menu"} color={"standard-text-color"}/>
                <p className="small-text-dark semi-bold text-margin-right text-margin-left">{(lessonInformation.title === "")?'Geef les een titel':lessonInformation.title}</p>
                {navigation && <><IconAtom
                    onClick={onClick}
                    size={"small"}
                    icon2={"edit"}
                    color={"var(--standard-text-color)"}
                />
                          
                </>}
                
                {/* <p className="small-text-light" style={{ marginLeft: "0.5rem" }}>{lessonInformation.duration} min</p> */}
                { message && ( <Alert className={"ai-loading"} type="warning" message={"De AI is bezig met genereren, je kunt de les nog niet sluiten."}/> ) }    
            </div>
  
            
            {navigation && <IconAtom onClick={remove} icon2={"trash"}/>}
        </div>
    )
}

export const LessonInputTitle = ({ placeholder, onClick,title,typeInput }) => {
    return (

        <div data-testid={"lesson-title-form-1"} className='horizontal'>

            <InputForm
                typeInput={(text) => typeInput(text)}
                value={title}
                placeholder={placeholder}
                style={{ marginBottom: "unset" }}
            />
            <IconAtom 
                
                onClick={onClick }
                icon2={"add"}
            />
        </div>
    )
}